import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { ActionEvent } from '../lib/_types';

export function VideoPreview() {
  const [videoSrc, setVideoSrc] = useState<string | undefined>(undefined);

  function closeVideoPreview() {
    const vel = document.querySelector('#sonaris-video-preview');
    if (vel) {
      vel.classList.remove('open');
    }
    setVideoSrc(undefined);
  }

  useEffect(() => {
    const ctrl = new AbortController();

    window.addEventListener(
      'toggle-video-open',
      (e) => {
        if ("data" in e && typeof e.data === 'string') {
          setVideoSrc(e.data);
          window.dispatchEvent(new ActionEvent('close-image-preview'));
        }
      },
      ctrl
    );

    window.addEventListener(
      'close-video-preview',
      () => {
        closeVideoPreview();
      },
      ctrl
    );

    return () => {
      // ctrl.abort();
    };
  }, []);

  function isYouTubeLink(url?: string) {
    return url?.includes('youtube.com') || url?.includes('youtu.be');
  }

  function getYouTubeEmbedURL(url: string) {
    const videoId = url.includes('youtu.be') 
      ? url.split('/').pop()
      : new URL(url).searchParams.get('v');
    return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1`;
  }

  return (
    <AnimatePresence>
      {videoSrc ? (
        <motion.div
          initial={{ scale: 0.7, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 pr-[350px]"
          onClick={closeVideoPreview}
        >
          {isYouTubeLink(videoSrc) ? (
            <iframe
              src={getYouTubeEmbedURL(videoSrc)}
              className="max-w-[70vw] max-h-[80vh] w-auto h-auto rounded-xl shadow-2xl border border-white/5"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <video
              className="max-w-[70vw] max-h-[80vh] w-auto h-auto rounded-xl shadow-2xl border border-white/5"
              autoPlay
              muted
              playsInline
              controls
            >
              <source src={videoSrc}></source>
            </video>
          )}
        </motion.div>
      ) : (
        <div className="hidden"></div>
      )}
    </AnimatePresence>
  );
}
